import { SparkResult } from "ags/integration/model/results/spark-result";
import DimSymbolsCommand, { DimType } from "slotworks/commands/symbols/dim-symbols-command";
import { HighlightSymbolsCommand } from "slotworks/commands/symbols/highlight-symbols-command";
import Components from "slotworks/components/components";
import Gamestate from "slotworks/model/game-state";
import GameState from "slotworks/model/game-state";
import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";
import { Services } from "slotworks/services/services";
import { SoundEvent } from "slotworks/services/sound/sound-events";
import State from "slotworks/state-machine/states/state";
import { unique } from "slotworks/utils/collection-utils";
import Contract from "slotworks/utils/contracts/contract";
import Point from "slotworks/utils/geom/point";
import Result from "slotworks/model/gameplay/records/results/result";

export default class AGSHighlightWins extends State {

    public onEnter() {
        this.highlightWins().then(() => {
            Components.matrix.resetSymbols();
            this.complete();
        });
    }

    protected highlightWins(): Contract<void> {
        if (GameState.currentRecordHasSymbolWinResults() || GameState.currentRecordHasBonusWinResults()) {

            const winningPositions = this.getWinningSymbolPositions();

            let winningSymbols = [];
            const winningSymbolIDs = [];

            for (const position of winningPositions) {
                const symbol = Components.matrix.getSymbol(position.x, position.y);
                winningSymbols.push(symbol);
                winningSymbolIDs.push(symbol.symbolId);
            }

            winningSymbols = unique(winningSymbols);
            const uniqueWinningSymbolIDs = unique(winningSymbolIDs);

            Services.sound.event(SoundEvent.highlight_all_wins);
            for (const symbolID of uniqueWinningSymbolIDs) {
                Services.sound.event(SoundEvent.symbol_ID_highlight, symbolID);
                let count = 0;
                for (const symbolToCount of winningSymbolIDs) {
                    if (symbolID === symbolToCount) {
                        count++;
                    }
                }
                Services.sound.event(SoundEvent.symbol_ID_MATCHES_highlight, symbolID, count.toString());
            }

            DimSymbolsCommand(Components.matrix.getAllSymbols(), DimType.Highlight).execute();

            return HighlightSymbolsCommand(winningSymbols);
        } else {
            return Contract.empty();
        }
    }

    protected getWinningSymbolPositions() {

        const currentRecord = Gamestate.getCurrentGame().getCurrentRecord();
        const allWins = currentRecord.results;
        let winningPositions: Point[] = [];

        for (const win of allWins) {
            const symbolWin = win as SymbolWinResult;
            if (this.isCelebratedResult(win)) {
                winningPositions = winningPositions.concat(symbolWin.positions);
            }
        }

        return winningPositions;
    }

    protected isCelebratedResult(win: Result) {
        return win instanceof SymbolWinResult || (win instanceof SparkResult && GameState.currentRecordHasBonusWinResults())
    }
}
